import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Guard component that redirects unauthenticated users away from Build routes
 * to the home page
 */
const BuildRouteGuard = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    // Wait for auth to finish loading
    if (!loading && !isAuthenticated) {
      // Redirect to home page if not authenticated
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Show nothing while loading or if not authenticated (redirecting)
  if (loading || !isAuthenticated) {
    return null;
  }

  // Render children if authenticated
  return children;
};

export default BuildRouteGuard;


